import { styled } from "styled-components";
import { Colors } from "../constants";
import { motion, AnimatePresence } from "framer-motion";
import DieRoll from "./DieRoll";

const Wrapper = styled.div`
  color: ${Colors.Tan};
  text-align: center;
  position: relative;
  font-family: "UnifrakturMaguntia", cursive;
  font-size: 80px;
  line-height: 100%;
  width: 100%;
  height: 100%;
  max-width: 1024px;
  padding: 0 32px;
  @media (max-width: 800px) {
    font-size: 48px;
    line-height: 100%;
    height: 256px;
    padding: 0 24px;
  }
`;

const NameWrapper = styled(motion.div)`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

const Headline = ({ title, character, roll }) => {
  const Name = () => {
    return (
      <NameWrapper
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ type: "ease-out", duration: 0.25 }}
      >
        {title}
      </NameWrapper>
    );
  };

  return (
    <Wrapper>
      <AnimatePresence>
        {roll === null ? (
          <Name />
        ) : (
          <DieRoll character={character} roll={roll} />
        )}
      </AnimatePresence>
    </Wrapper>
  );
};

export default Headline;
